export default __webpack_public_path__ + "static/media/4.d385eb5f.png";